(function documentViewerrModuleDefinition() {
    'use strict';

    angular.module('DocumentViewer', [])
        .directive('documentViewer', ['$translate',
            function ($translate) {
                return {
                    scope: {
                        src: '='
                    },

                    controller: [
                        '$scope', '$element', function ($scope, $element) {
                            
                            function detectIE() {
                                var ua = window.navigator.userAgent;

                                var msie = ua.indexOf('MSIE ');
                                if (msie > 0) {
                                    // IE 10 or older => return version number
                                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                                }

                                var trident = ua.indexOf('Trident/');
                                if (trident > 0) {
                                    // IE 11 => return version number
                                    var rv = ua.indexOf('rv:');
                                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                                }

                                return false;
                            };

                            $scope.IsIe = detectIE();
                        }],
                    restrict: 'E',
                    templateUrl: '/app/components/document-viewer/document-viewer.html',
                    link: function ($scope) {
                        $scope.$watch('src', function (value) {
                            // all the code here...
                            if(value)
                                $scope.src = value;
                        });
                    }
                };
            }
        ]);
})();